<mat-spinner *ngIf="visible" diameter="64"></mat-spinner>
